(function ($) {
  DJ.addBehavior('DataParagraph', '.data__cta', {
    attach: function (context, settings) {
      document.addEventListener('click', function (event) {
        document.querySelectorAll('.data__cta details').forEach((details) => {
          if (details.hasAttribute('open') && !details.contains(event.target)) {
            details.removeAttribute('open');
          }
        });
      });
    },
    detach: function (context, settings) {}
  });
})(jQuery);
